import React from "react";
import {Col, Row} from "react-bootstrap";
import styles from "./AdminPreview.module.css";
import LoaderGraph from "../../general/LoaderGraph";
import moment from "moment-timezone";

const AdminSitePreview = (props) => {
	// sd = site data
	const sd = props.dataPreview?.site_id != null ? props.dataPreview : {};

	return (
		<div className={`form-contents ${styles.adminPreview}`}>
			{sd.site_id != null ? (
				<div>
					<Row>
						<Col sm="11"></Col>
						<Col sm="1">
							<span
								onClick={() => props.closed()}
								style={{float: "right", cursor: "pointer"}}
								className="glyphicon glyphicon-remove close-approval"
							></span>
						</Col>
					</Row>
					<h3>
						{sd.temp_client_name} - {sd.site_name}
					</h3>
					<Row>
						<Col sm={6}>
							<p><span>Temporary Site ID: </span>{sd.site_id}</p>
							<p><span>Client ID: </span>{sd.client_id === null ? "temporary new" : sd.client_id}</p>
							{sd.client_id === null && <p><span>Grand new Client ID: </span>
								{sd.exu_cl === null ? sd.client_id === null ? "not yet created" : sd.client_id : sd.exu_cl}
							</p>}
							<p><span>Grand new Site ID: </span>
								{sd.exu_site === null ? "not yet created" : sd.exu_site}
							</p>
							<p><span>Solo/ Multi: </span>{sd.solo === 1 ? "Solo" : "Multi"}</p>
							<p><span>EDMI: </span>{sd.EDMI_meter === 1 ? "Yes" : "No"}</p>
							<p><span>Safesforce ID: </span>{sd.SF_id || "empty"}</p>
							<p><span>Take or Pay Scheme: </span>{sd.ToP === 1 ? "Yes" : "No"}</p>
							<p><span>GPS: </span>{sd.GPS || "empty"}</p>
							<p><span>Site capacity: </span>{sd.power || "empty"} kWp</p>
							<p><span>Site address: </span>{sd.address !== null ? sd.address : "empty"}</p>
							<p><span>Site zipcode: </span>{sd.zipcode !== null ? sd.zipcode : "empty"}</p>
							<p><span>Site city: </span>{sd.city !== null ? sd.city : "empty"}</p>
							<p><span>Site country: </span>{sd.country !== null ? sd.country : "empty"}</p>
							<p><span>Estimated COD: </span>
								{sd.cod !== null ? moment(sd.cod).format("YYYY-MM-DD") : "empty"}
							</p>
							<p><span>Estimated sync date: </span>
								{sd.cod !== null ? moment(sd.sync).format("YYYY-MM-DD") : "empty"}
							</p>
							<p><span>Contract: </span>
								{sd.contract_id !== null ? sd.contract_id : "empty"} -{" "}
								{sd.contract_duration !== null ? `${sd.contract_duration} years` : "empty"}
							</p>
							<p><span>MSA Price: </span>
								{sd.msa_price !== null ? `${sd.msa_price} THB` : "empty"}
							</p>
							<p><span>Inverter: </span>
								{sd.nb_inverter !== null ? `${sd.nb_inverter}` : "0"} inverters{" "}
								- {sd.inverter_id !== null ? sd.inverter_id : "empty"}
							</p>
							<p><span>Number of irradiance sensors: </span>{sd.nb_irr_sensors !== null ? `${sd.nb_irr_sensors}` : "0"}</p>
							<p><span>Number of injection points: </span>{sd.nb_inj_points !== null ? `${sd.nb_inj_points}` : "0"}</p>
							<p><span>Solar panel modules: </span>{sd.nb_solar_modules !== null ? `${sd.nb_solar_modules} panels` : "0 panel"} {" "}
								- {sd.temp_solar_module !== null ? sd.temp_solar_module : "empty module name"}
							</p>
							<p><span>Solar panel module ID: </span>
								{sd.solar_module_id === null ? "temporary new" : sd.solar_module_id}
							</p>
							{sd.solar_module_id === null && <p><span>Grand new Solar module Panel: </span>
								{sd.exu_mdl === null ? "not yet created" : sd.exu_mdl}
							</p>}
							<p><span>Number of grid meters: </span>{sd.nb_grid_meter !== null ? `${sd.nb_grid_meter}` : "0"}</p>
							<p><span>Number of ambient temperature sensor: </span>{sd.nb_amb_temp !== null ? `${sd.nb_amb_temp}` : "0"}</p>
							<p><span>Number of module temperature sensor: </span>{sd.nb_mod_temp !== null ? `${sd.nb_mod_temp}` : "0"}</p>
							<p><span>Grid Voltage: </span>{sd.reference_voltage !== null ? `${sd.reference_voltage}` : "-"}</p>
							<p><span>KPMAX: </span>{sd.coeff_kpmax !== null ? `${sd.coeff_kpmax}` : "0"}</p>
							<p><span>DGPT2: </span>{sd.DGPT2 !== null ? `${sd.DGPT2}` : "0"}</p>
							<p><span>Water: </span>{sd.water !== null ? `${sd.water}` : "0"}</p>
							<p><span>Wind direction: </span>{sd.water !== null ? `${sd.water}` : "0"}</p>
							<p><span>Wind speed: </span>{sd.wind_speed !== null ? `${sd.wind_speed}` : "0"}</p>
							<p><span>Construction Comment: </span>{sd.pm_comment !== null ? `${sd.pm_comment}` : "none"}</p>
						</Col>

						<Col sm={6}>
							<p><span>Temporary Invoicing info ID: </span>{sd.acct_id}</p>
							<p><span>Invoicing info is sent for approval? </span>{sd.isSent_acct === 0 ? "Not yet" : "Sent"}</p>
							<p><span>Site code: </span>{sd.site_code === null ? "empty" : sd.site_code}</p>
							<p><span>Tax ID: </span>{sd.tax_id === null ? "empty" : sd.tax_id}</p>
							<p><span>Site location: </span>{sd.location === null ? "empty" : sd.location}</p>
							<p><span>Billing name: </span>{sd.billing_name === null ? "empty" : sd.billing_name}</p>
							<p><span>Billing address: </span>{sd.billing_address === null ? "empty" : sd.billing_address}</p>
							<p><span>Credit term: </span>{sd.credit_term !== null ? `${sd.credit_term} days` : "empty"}</p>
							<p><span>Currency: </span>{sd.currency !== null ? `${sd.currency}` : "empty"}</p>
							<p><span>Electricity authority: </span>{sd.EA_id !== null ? `${sd.EA_id}` : "empty"}</p>
							<p><span>Solar entity: </span>{sd.solar_entity !== null ? `${sd.solar_entity}` : "empty"}</p>
							<p><span>Bank ID: </span>{sd.bank_id !== null ? `${sd.bank_id}` : "empty"}</p>
							{sd.bank_id === null && <p><span>Bank account name: </span>{sd.bank_acc_name !== null ? `${sd.bank_acc_name}` : "empty"}</p>}
							{sd.bank_id === null && <p><span>Bank account number: </span>{sd.bank_acc_number !== null ? `${sd.bank_acc_number}` : "empty"}</p>}
							<p><span>Tariff type: </span>{sd.tariff_id !== null ? `${sd.tariff_id}` : "empty"}</p>
							<p><span>Price ID: </span>{sd.price_id !== null ? `${sd.price_id}` : "empty"}</p>
							<p><span>Price ON PEAK: </span>{sd.price_on !== null ? `${sd.price_on}` : "empty"}</p>
							<p><span>Price OFF PEAK: </span>{sd.price_off !== null ? `${sd.price_off}` : "empty"}</p>
							<p><span>FT cost: </span>{sd.FT_cost !== null ? `${sd.FT_cost}` : "empty"}</p>
							<p><span>FT discount: </span>{sd.FT_discount !== null ? `${sd.FT_discount}%` : "empty"}</p>
							<p><span>Discount ON PEAK: </span>{sd.discount_on !== null ? `${sd.discount_on}%` : "empty"}</p>
							<p><span>Discount OFF PEAK: </span>{sd.discount_off !== null ? `${sd.discount_off}%` : "empty"}</p>
							<p><span>Postal ID: </span>{sd.discount_off !== null ? `${sd.discount_off}` : "empty"}</p>
							<p><span>Invoicing info Comment: </span>{sd.acct_comment !== null ? `${sd.acct_comment}` : "none"}</p>
							{sd.postal_id !== null && <p><span>Postal ID: </span>{sd.postal_id == 0 ? "temporary new" : sd.postal_id}</p>}
							{sd.postal_id !== null && <p><span>Postal attention: </span>{sd.mail_name === null ? "empty" : sd.mail_name}</p>}
							{sd.postal_id !== null && <p><span>Postal address: </span>{sd.mail_bill_add === null ? "empty" : sd.mail_bill_add}</p>}
							{sd.postal_id !== null && <p><span>Postal phone number: </span>{sd.mail_phone_no === null ? "empty" : sd.mail_phone_no}</p>}
							<p><span>Table name: </span>{sd.table_name === null ? "not yet updated" : sd.table_name}</p>
							<p><span>IT executed Invoicing info?: </span>{sd.isExecuted === 0 ? "not yet updated" : "Yes"}</p>
						</Col>

					</Row>
				</div>
			) : (
				<LoaderGraph />
			)}

			<div className="btn-container">
				<Row>
					<Col md="3"></Col>
					<Col md="3">
						<button
							className="btn btn-primary btn-generate btn-approval"
							title="Close"
							onClick={() => props.closed()}
						>
							<span>Close</span>
						</button>
					</Col>
					<Col md="3"></Col>
				</Row>
			</div>
		</div>
	);
};

export default AdminSitePreview;
